import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { LayoutDashboard, Radar, ShieldCheck, Radio, AlertTriangle } from "lucide-react";

export const Route = createFileRoute("/_authenticated/dashboards")({
  component: DashboardsLayout,
  head: () => ({ meta: [{ title: "Dashboards — MissionReady" }] }),
});

const TABS: Array<{ to: string; label: string; icon: any; exact?: boolean }> = [
  { to: "/dashboards", label: "Executive", icon: LayoutDashboard, exact: true },
  { to: "/dashboards/pulse", label: "Live Pulse", icon: Radar },
  { to: "/dashboards/compliance", label: "Compliance", icon: ShieldCheck },
  { to: "/dashboards/dispatch", label: "Dispatch", icon: Radio },
  { to: "/dashboards/incidents", label: "Incidents", icon: AlertTriangle },
];

function DashboardsLayout() {
  const loc = useLocation();
  return (
    <div className="px-3 py-4 md:px-8 md:py-6">
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wider text-primary">Operations intelligence</p>
        <h1 className="font-display text-2xl font-bold md:text-3xl">Admin dashboards</h1>
      </div>
      <nav className="mt-4 flex gap-1 overflow-x-auto border-b border-border">
        {TABS.map((t) => {
          const active = t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to);
          const Icon = t.icon;
          return (
            <Link key={t.to} to={t.to as any}
              className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2 text-sm transition-colors ${
                active ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
              }`}>
              <Icon className="h-4 w-4" /> {t.label}
            </Link>
          );
        })}
      </nav>
      <div className="mt-5"><Outlet /></div>
    </div>
  );
}
